import React from "react";
import "./DefaultImagingSettingCheckBox.css";

type Props = {
  name: string;
  label: string;
  checked: boolean;
  onChange: (name: string, value: boolean) => void;
  style?: React.CSSProperties;
  disabled: boolean;
};

export default function DefaultImagingSettingCheckBox({ name, label, checked, onChange, style, disabled }: Props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "transparent",
        color: "#000000",
        ...style,
      }}
    >
      <label
        className={disabled ? "cb-img-setting-container cb-img-setting-container-disabled" : "cb-img-setting-container"}
        style={{
          lineHeight: "16px",
          textAlign: "left",
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <input
          type="radio"
          name={name}
          checked={checked}
          onClick={(e) => onChange(name, !checked)}
          disabled={disabled}
        />
        <span className="cb-img-setting-checkmark" />
        {label}
      </label>
    </div>
  );
}
